import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/models/user';
import { CommonService } from 'src/app/services/common.service';
import { OtpService } from 'src/app/services/otp.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-mobile-find-id',
  templateUrl: './mobile-find-id.component.html',
  styleUrls: ['./mobile-find-id.component.css']
})
export class MobileFindIdComponent implements OnInit {

  constructor(
    private userService: UserService,
    private commonService: CommonService,
    private otpService: OtpService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router
  ) {
    if(!this.commonService.getIsMobile()) {
      this.router.navigate(['/find/id'])
    }
  }
  name: string
  tel: string
  otpCode: string
  ngOnInit(): void {
    let user: User = this.commonService.getUserInfo()
    if(user) {
      this.router.navigate(['/'])
    }
    /*
    this.list = new Array()
    let f1 = new FindUser()
    f1.userId = 'momomo8080'
    f1.regDate = '2024-09-03T11:16:15'
    let f2 = new FindUser()
    f2.userId = 'momomo808'
    f2.regDate = '2023-12-03T11:16:15'
    this.list.push(f1)
    this.list.push(f2)
    this.userId = 'momomo808'
    this.otpCode = '1234'
    */
  }
  list: FindUser[]
  isDoFindId: boolean = false
  userId: string
  findId() {
    if(!this.name) {
      return alert('이름을 입력해 주세요')
    }
    if(!this.isOtpConfirm) {
      return alert('핸드폰 인증을 진행해 주세요')
    }
    this.list = null
    this.spinner.show()
    this.userService.findUserId(this.name, this.tel, this.otpCode).subscribe(res => {
      this.spinner.hide()
      if(res.resultCode == '0000') {
        this.isDoFindId = true
        this.list = res.data
        if(this.list) {
          this.userId = this.list[0].userId
        }
      } else {
        alert(res.message)
        this.name = null
        this.tel = null
        this.otpCode = null
        this.isOtpSend = false
        this.isOtpConfirmTry = false
        this.isOtpConfirm = false
        this.displayTime = null
        this.timerInterval = null
      }
    });
  }

  isOtpSend: boolean = false
  otpSend() {
    if(!this.tel) {
      return alert("핸드폰 번호를 입력해 주세요")
    }
    this.tel = this.tel.replace(/-/gi, "")
    if(!(this.tel.startsWith('010') && this.tel.length == 11)) {
      return alert("핸드폰 번호를 확인해 주세요")
    }
    this.otpService.findIdOtpSend(this.tel).subscribe(res => {
      this.isOtpSend = true
      this.otpCode = null
      this.timer()
    })
  }

  isOtpConfirmTry: boolean = false
  isOtpConfirm: boolean = false
  otpCheck() {
    if(!this.otpCode) {
      return alert("인증번호를 입력해 주세요")
    }
    this.isOtpConfirmTry = true
    this.otpService.findIdOtpCheck(this.tel, this.otpCode, this.intervalCheckTime).subscribe(res => {
      this.isOtpConfirm = res.data
      this.displayTime = ''
      clearInterval(this.timerInterval)
      if(this.isOtpConfirm) {
        this.toastr.success("인증이 완료되었습니다")
      } else {
        alert("인증번호가 일치하지 않습니다")
        this.isOtpConfirmTry = false
        this.isOtpSend = false
        this.otpCode = null
        this.tel = null
      }
    })
  }
  intervalCheckTime: number = 5
  displayTime: string
  timerInterval: any
  timer() {
    let minute = this.intervalCheckTime
    let seconds: number = minute * 60
    let textSec: any = "0"
    let statSec: number = 60
    const prefix = minute < 10 ? "0" : "";
    this.timerInterval = setInterval(() => {
      seconds--
      if (statSec != 0) {
        statSec--
      } else {
        statSec = 59
      }
      if (statSec < 10) {
        textSec = "0" + statSec;
      } else {
        textSec = statSec;
      }
      this.displayTime =  prefix + (Math.floor(seconds / 60)) + ':' + textSec
      if (seconds == 0) {
        clearInterval(this.timerInterval)
        this.isOtpSend = false
      }
    }, 1000)
  }
}
export class FindUser {
    regDate: string
    tel: string
    userId: string
    userName: string
    userNo: number
}
